import gql from 'graphql-tag';

export const queryForFacilities = gql`
  query queryForFacilities(
    $limit: Int
    $page: Int
    $query: FacilitySortOrQuery
    $sort: FacilitySortOrQuery
  ) {
    queryForFacilities(limit: $limit, page: $page, query: $query, sort: $sort) {
      items {
        id
        facilityName
        facilityUid
        facilityType
        scadaId
        state
        county
        township
        aors
        company
        hidden
      }
      totalRecords
    }
  }
`;
